<script setup>
import WorkflowAutomationWizard from "@/components/workflow-automations/WorkflowAutomationWizard.vue";
import axios from "@/utils/axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useRoute, useRouter } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { useLoading } from "vue-loading-overlay";
import loaderData from "@/utils/loader-data";

const route = useRoute();
const router = useRouter();
const $loading = useLoading(loaderData);

const automationData = ref(null);
const isReadOnly = computed(() => route.query.mode === "view");

const fetchAutomation = () => {
  let loader = $loading.show();
  axios
    .get(`/workflow_automations/${route.params.id}`)
    .then((response) => {
      if (response.status === "success") {
        automationData.value = response.data.workflow_automation;
      } else {
        toast.error(response.message, { autoClose: 2000 });
      }
    })
    .catch(() => {
      toast.error("Failed to load workflow automation", { autoClose: 2000 });
    })
    .finally(() => loader.hide());
};

const saveAutomation = (payload) => {
  let loader = $loading.show();
  axios
    .put(`/workflow_automations/${route.params.id}`, payload)
    .then((response) => {
      if (response.status === "success") {
        toast.success(response.message, { autoClose: 3000 });
        router.push({ name: "workflow-automations-list" });
      } else {
        toast.error(response.message, { autoClose: 2000 });
      }
    })
    .catch(() => {
      toast.error("Failed to update workflow automation", { autoClose: 2000 });
    })
    .finally(() => loader.hide());
};

const discardChanges = () => {
  router.push({ name: "workflow-automations-list" });
};

onMounted(fetchAutomation);

definePage({ meta: { requiresAuth: true } });
</script>

<template>
  <div v-if="automationData">
    <WorkflowAutomationWizard
      :initial-data="automationData"
      submit-label="Update Automation"
      :read-only="isReadOnly"
      @save="saveAutomation"
      @cancel="discardChanges"
    />
  </div>
</template>
